import { useSuspenseApiGetBiMetric } from '@repo/api-codegen';
import { useEffect, useMemo } from 'react';
import { useAuthUser, useWorkspace } from '../../../api';
import type { BIDashboardStore } from '../../BiDashboard/store';
import { BIMetricStore } from '../store';

export const useSuspenseBiMetricStore = (
	metricId: string,
	editable: boolean = true,
	dashboardStore?: BIDashboardStore
) => {
	const { data: metric } = useSuspenseApiGetBiMetric({
		pathParams: {
			biMetricId: metricId,
		},
	});

	const { user } = useAuthUser();
	const { workspace } = useWorkspace();

	const store = useMemo(() => {
		if (dashboardStore) {
			return dashboardStore.getOrCreateMetricStore(metricId, metric);
		}

		return new BIMetricStore({
			metric,
			editable,
			user,
			workspace,
			isInDashboard: false, // Individual metric views are tracked
		});
	}, [dashboardStore, metricId, metric, editable, user, workspace]);

	// eslint-disable-next-line no-use-effect/no-use-effect
	useEffect(() => {
		store.syncWithLatestUpdate(metric);
	}, [store, metric]);

	return {
		store,
		metric,
	};
};
